module.exports = __webpack_public_path__ + "static/media/logo-transparent.7ab05318.png";